<template>
  <div class="free">
    <div class="pain">
      <div class="big-title">
        <p>行业痛点</p>
        <div class="line"></div>
        <div class="desc">传统营销解决方案现存行业痛点</div>
      </div>
      <div class="pain-box row-center">
        <div
          class="pain-item column-center"
          v-for="item in painList"
          :key="item.id"
        >
          <img :src="item.img" />
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="frame column-center">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">商家，用户互惠互利，创造城市专属的双十一</div>
      </div>
      <div class="frame-box row-center">
        <img src="../../static/images/product/yykj.png" />
      </div>
    </div>
    <div class="share">
      <div class="big-title">
        <p>共享裂变</p>
        <div class="line"></div>
        <div class="desc">符合时代的共享裂变方式，同步推广获取收益</div>
      </div>
      <div class="share-box row-center">
        <div class="share-item" v-for="item in shareList" :key="item.id">
          <img :src="item.img" />
          <div class="right">
            <h2>{{ item.title }}</h2>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="value column-center">
      <div class="big-title">
        <p>核心价值</p>
        <div class="line"></div>
        <div class="desc">增加客户粘性，获取持续稳定的客源</div>
      </div>
      <div class="value-box">
        <div class="value-item" v-for="item in valueList" :key="item.id">
          <div class="title">
            <img :src="item.img" />
            <h2>{{ item.title }}</h2>
          </div>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="case">
      <div class="big-title">
        <p>应用案例</p>
        <div class="line"></div>
        <div class="desc">案例示范，为商家提供有效的宣传方案</div>
      </div>
      <div class="case-box row-center">
        <img src="../../static/images/product/p1.png" />
        <img src="../../static/images/product/p2.png" />
        <div class="action">
          <div class="content-text">
            <h2>清远免单节活动</h2>
            <div class="item">
              <h3>区域</h3>
              <p>广东清远 各类行业</p>
            </div>
            <div class="item">
              <h3 class="center-mar">简介</h3>
              <p>
                是与清远广电联合举办的免单节活动，各
                类商家均可参与，以此来营销自己的商铺
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <address class="five-footer">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a @click="jumpService">立即咨询</a>
    </address>
  </div>
</template>

<script>
export default {
  data() {
    return {
      painList: [
        {
          id: 0,
          img: require("../../static/images/product/th.png"),
          desc: "同行竞争激烈",
        },
        {
          id: 1,
          img: require("../../static/images/product/cx.png"),
          desc: "促销方式传统且缺乏创意",
        },
        {
          id: 2,
          img: require("../../static/images/product/cxld.png"),
          desc: "促销力度不够大",
        },
        {
          id: 3,
          img: require("../../static/images/product/tk.png"),
          desc: "拓客难度大，锁客难度太高",
        },
      ],
      shareList: [
        {
          id: 0,
          img: require("../../static/images/product/gxfl.png"),
          title: "共享福利",
          desc: "每个商家都拿出200元的福利，50个商家福利总价值达上万元",
        },
        {
          id: 1,
          img: require("../../static/images/product/ll.png"),
          title: "共享流量",
          desc: "每个商家共享50个客户，50个商家共享的客户就有上千名",
        },
        {
          id: 2,
          img: require("../../static/images/product/lb.png"),
          title: "裂变流量",
          desc: "微信转发好友并推荐购买就有100元现金红包到账，不上限",
        },
      ],
      valueList: [
        {
          id: 0,
          img: require("../../static/images/product/value_1.png"),
          title: "持续稳定的客源",
          desc: "客源是商家可持续发展的稳定基础，有稳定的客源才能更长久的发展",
        },
        {
          id: 1,
          img: require("../../static/images/product/value_2.png"),
          title: "成倍的业绩增长",
          desc: "免单的营销方式符合现代人的口味，这种营销方式也使得业绩倍增",
        },
        {
          id: 2,
          img: require("../../static/images/product/value_3.png"),
          title: "联盟商家的资源置换",
          desc: "单一的营销模式利益固然比不得商家的联盟来得快，资源置换可互惠互利",
        },
        {
          id: 3,
          img: require("../../static/images/product/value_4.png"),
          title: "良好的员工团队打造",
          desc: "营销离不开员工的辛勤付出，而良好的员工团队可让营销方式更上一层楼",
        },
        {
          id: 4,
          img: require("../../static/images/product/value_5.png"),
          title: "品牌的持续曝光影响力",
          desc: "品牌的影响力是商家可持续发展的原动力，因此持续曝光品牌是很有必要的",
        },
      ],
    };
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.free {
  .column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .row-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pain-box {
    padding-bottom: 80px;

    .pain-item {
      width: 328px;
      height: 240px;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      margin-right: 30px;

      p {
        margin-top: 45px;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
      }
    }

    .pain-item:hover {
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    }
  }

  .frame {
    padding: 0 0 80px 0;
    background: #F7F7F7;

    .frame-box {
      width: 1400px;
      height: 623px;
      background: #FFFFFF;
    }
  }

  .share-item {
    width: 446px;
    height: 145px;
    background: rgba(255, 192, 0, 0.08);
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    margin-right: 30px;

    img {
      margin-top: -40px;
      margin-left: 10px;
    }

    .right {
      margin: 10px 46px 0 86px;

      h2 {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
      }
    }
  }

  .value-box {
    position: relative;
    margin-top: 100px;
    background: url('../../static/images/product/jz.png') no-repeat center center;
    height: 550px;
    width: 495px;

    .value-item {
      padding: 25px 24px;
      box-sizing: border-box;
      width: 370px;
      height: 137px;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 4px;

      .title {
        display: flex;
        align-items: center;
      }

      img {
        width: 28px;
        height: 28px;
      }

      h2 {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        margin-left: 12px;
      }

      p {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        margin-left: 40px;
      }
    }
  }

  .value-item:nth-child(1) {
    position: absolute;
    top: -80px;
    left: 50px;
  }

  .value-item:nth-child(2) {
    position: absolute;
    top: 100px;
    left: -350px;
  }

  .value-item:nth-child(3) {
    position: absolute;
    top: 330px;
    left: -270px;
  }

  .value-item:nth-child(4) {
    position: absolute;
    top: 330px;
    left: 390px;
  }

  .value-item:nth-child(5) {
    position: absolute;
    top: 100px;
    left: 480px;
  }

  .case-box {
    position: relative;
    height: 457px;
    margin-top: 160px;
    align-items: flex-start;

    img {
      position: absolute;
      z-index: 1;
    }

    img:nth-child(1) {
      top: -100px;
      left: 400px;
    }

    img:nth-child(2) {
      top: -100px;
      left: 750px;
    }

    .action {
      position: relative;
      width: 1400px;
      height: 260px;
      background: #F7F7F7;

      .content-text {
        position: absolute;
        right: 140px;
        top: 40px;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 25px;
        }

        .center-mar {
          margin-top: -25px;
        }

        h2 {
          position: relative;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 23px;
        }

        h2:after {
          position: absolute;
          content: '';
          width: 40px;
          height: 3px;
          background: #FFC000;
          top: 50px;
          left: 0px;
        }

        h3 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }

        p {
          position: relative;
          width: 340px;
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          margin-left: 36px;
          line-height: 28px;
        }

        p::before {
          position: absolute;
          content: '';
          width: 4px;
          height: 4px;
          top: 8px;
          left: -20px;
          background: #FFC000;
        }
      }
    }
  }

  .five-footer {
    width: 100%;
    height: 160px;
    background: url('../../static/images/fiveG/bg(1).png');
    text-align: center;
    border-sizing: border-box;
    position: relative;
    z-index: 3;

    h3 {
      padding-top: 20px;
      font-size: 25px;
      line-height: 50px;
      color: #FFFDF9;
    }

    a {
      text-decoration: none;
      display: inline-block;
      width: 200px;
      height: 44px;
      margin: 16px auto;
      font-size: 22px;
      color: #FFFEFC;
      line-height: 44px;
      border: 1px solid #FFFEFC;
      border-radius: 5px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 80px;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    width: 614px;
    margin: 24px 0 45px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/FreeProgram.vue